import { RQ } from 'utils';
import { share } from 'utils/wx';

export default {
  debug: function () {
    localStorage.setItem('debug', '1');
    window.location.reload();
  },
  closeDebug: function () {
    localStorage.setItem('debug', '0');
    window.location.reload();
  }
};



// WEBPACK FOOTER //
// ./src/module/app/debug/action.js